// @ vendors
const React = require('react');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ commons
const { OKLink } = require('commonsComponents/OKLink');

// @constants
const {
    HOME_USE,
    MORTGAGE_TYPE,
    HOUSING_STATUS,
} = require('constants/mortgageRequestMortgageDataTypes');

const { MORTGAGE_SIMULATOR_TOTAL_COSTS } = require('constants/links');
const communityCodes = require('constants/communityCodes').codes;
const { modifyMortgageMonthlyFeeTitleText, modifyMortgageMonthlyFeeSubtitleText } = require('utilities/mortgageHelper');

const updateExternalUrl = (state, infoRelatedProducts) => {
    let url = MORTGAGE_SIMULATOR_TOTAL_COSTS.replace('VALOR_VIVIENDA', state.importeVivienda)
        .replace('UBICACION_VIVIENDA', communityCodes[state.comunidadAutonoma])
        .replace('TIPO_VIVIENDA', state.finalidad === HOME_USE.PRIMERA_VIVIENDA ? '01' : '15')
        .replace('ANIOS', state.plazo)
        .replace('MONTO_HIPOTECA', state.importeHipoteca)
        .replace('VIVIENDA_NUEVA', state.estadoVivienda === HOUSING_STATUS.NUEVA ? true : false)
        .replace('MOSTRAR_INFORME', 1)
        .replace('MORT_TYPE', MORTGAGE_TYPE[state.tipoProducto]);

    if (infoRelatedProducts && infoRelatedProducts.insurance) {
        const {
            firstImport,
            paymentType,
            succesiveImport,
        } = infoRelatedProducts.insurance;

        const hireInsurance = Number(state.incluyeSeguroHogar);

        if (succesiveImport > 0) {
            url = `${url}&cuotaSeguro=${succesiveImport}&frecuenciaSeguro=${paymentType}&primeraCuotaSeguro=${firstImport}&contrataSeguro=${hireInsurance}`;
        } else {
            url = `${url}&cuotaSeguro=${firstImport}&frecuenciaSeguro=${paymentType}&contrataSeguro=${hireInsurance}`;
        }
    }

    return url;
}

const buildInfoCalculate = (cuotaCurrent, cuotaRestoCurrent, state, infoRelatedProducts = {}, interestType, plazoFijo) => {

    const QUOTE_TITLE = modifyMortgageMonthlyFeeTitleText(interestType, cuotaCurrent, cuotaRestoCurrent);
    const QUOTE_CONDITIONS_LINK = formatText('mortgageRequestMortgageEdit-quoteConditionsLink')

    const amount = modifyMortgageMonthlyFeeSubtitleText(interestType, cuotaCurrent, cuotaRestoCurrent, plazoFijo);
    
    const _externalUrl = updateExternalUrl(state, infoRelatedProducts)
    return (
        <div className="mortgage-request-mortgage-edit-form__info">
            <h2 className="mortgage-request-mortgage-edit-form__quote-data__subtitle-2">{QUOTE_TITLE}</h2>
            <div className="mortgage-request-mortgage-edit-form__quote-data__amount">
                {amount}
            </div>

            <OKLink modifier="emphasize" name={'conditionsLinks'} to={_externalUrl} target="_blank" >
                {QUOTE_CONDITIONS_LINK}
            </OKLink>
        </div>
    );
}

const buildInfoActions = () => {
    const CALCULATE_TEXT = formatText('mortgageRequestCommons-calcularText');
    const CALCULATE_MESSAGE_1 = formatText('mortgageRequestMortgageEdit-messageActionCalculate1');
    const CALCULATE_MESSAGE_2 = formatText('mortgageRequestMortgageEdit-messageActionCalculate2')
    const CANCEL_TEXT = formatText('mortgageRequestCommons-cancelText');
    const CANCEL_MESSAGE_1 = formatText('mortgageRequestMortgageEdit-messageActionCancel1');
    const CANCEL_MESSAGE_2 = formatText('mortgageRequestMortgageEdit-messageActionCancel2');
    return (
        <div className="mortgage-request-mortgage-edit-form__info-actions">
            <p>{CALCULATE_MESSAGE_1} <strong>{CALCULATE_TEXT}</strong> {CALCULATE_MESSAGE_2}</p>
            <p>{CANCEL_MESSAGE_1} <strong>{CANCEL_TEXT}</strong> {CANCEL_MESSAGE_2}</p>
        </div>
    );
}

module.exports = {
    buildInfoCalculate,
    buildInfoActions
}
